module.exports = __webpack_public_path__ + "static/media/icon512.9d6be410.svg";